import { QuestionHeader } from "./question-header";

export default QuestionHeader;
